import { render } from "./mailing-builder.vue?vue&type=template&id=000db913&scoped=true"
import script from "./mailing-builder.vue?vue&type=script&lang=js"
export * from "./mailing-builder.vue?vue&type=script&lang=js"

import "./mailing-builder.vue?vue&type=style&index=0&id=000db913&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000db913"]])

export default __exports__